interface Props {
  label: string;
  value: string | number;
  hint?: string;
  tone?: "ok" | "warn" | "alert";
}

const TONE_BORDER: Record<NonNullable<Props["tone"]>, string> = {
  ok: "border-kw-l2",
  warn: "border-kw-l4",
  alert: "border-red-400",
};

export default function StatCard({ label, value, hint, tone = "ok" }: Props) {
  return (
    <div
      className={`px-4 py-3 bg-kw-bg-elevated rounded border-l-4 ${TONE_BORDER[tone]}`}
    >
      <div className="text-[10px] text-kw-text-faint uppercase tracking-wide">
        {label}
      </div>
      <div className="text-xl font-mono text-kw-text-primary">{value}</div>
      {hint && <div className="text-xs text-kw-text-muted mt-1">{hint}</div>}
    </div>
  );
}
